'use es6';

import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIUpgradeBanner from 'ui-addon-upgrades/ums/UIUpgradeBanner';
import AnnouncementBanner from 'ContentEditorUI/components/AnnouncementBanner';
import InvalidModuleBodyWarning from 'ContentEditorUI/components/temp/InvalidModuleBodyWarning';
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import { getIsUngatedForPatagonia, getShouldShowRemoveBrandingMessage } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getHasContentTypeLimitReducerAndExceededLimit } from 'ContentEditorUI/redux/selectors/limitSelectors';
import { getHasInvalidModuleBodyError } from 'ContentEditorUI/redux/selectors/moduleErrorSelectors';
import { getShouldShowSmartRulePreviewToolbar } from 'ContentEditorUI/redux/selectors/smartViewSelectors';
import { COLLAPSED_SIDEBAR_WIDTH } from 'collaboration-sidebar';
import LimitExceededError from './LimitExceededError';
import { jsx as _jsx } from "react/jsx-runtime";
const SIDEBAR_WIDTH = '380';
const FEB_09_2024 = 1707454800000; // Fri Feb 09 2024 00:00:00 GMT-0500 (Eastern Standard Time)
const FEB_16_2024 = 1708059600000; // Fri Feb 16 2024 00:00:00 GMT-0500 (Eastern Standard Time)
const FEB_23_2024 = 1708664400000; // Fri Feb 23 2024 00:00:00 GMT-0500 (Eastern Standard Time)

const MessagingWrapper = styled.div.withConfig({
  displayName: "BlogIframeMessagingAreaContainer__MessagingWrapper",
  componentId: "iydrc8-0"
})(["min-width:100%;width:calc(100vw - ", "px - ", "px);"], SIDEBAR_WIDTH, COLLAPSED_SIDEBAR_WIDTH);
const BlogIframeMessagingAreaContainer = () => {
  const shouldShowSmartRulePreviewToolbar = useSelector(getShouldShowSmartRulePreviewToolbar);
  const shouldShowRemoveBrandingMessage = useSelector(getShouldShowRemoveBrandingMessage);
  const shouldShowLimitExceededMessage = useSelector(getHasContentTypeLimitReducerAndExceededLimit);
  const blogHasInvalidModuleBodies = useSelector(getHasInvalidModuleBodyError);
  const isUngatedForPatagonia = useSelector(getIsUngatedForPatagonia);
  const memoizedMessageNodes = useMemo(() => {
    const messageNodes = [];
    if (shouldShowSmartRulePreviewToolbar) {
      messageNodes.push( /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
        children: ({
          SmartRulePreviewToolbar
        }) => /*#__PURE__*/_jsx(SmartRulePreviewToolbar, {}, "smart-rule-preview-toolbar")
      }));
    }
    if (shouldShowLimitExceededMessage) {
      messageNodes.push( /*#__PURE__*/_jsx(LimitExceededError, {}));
    }
    if (shouldShowRemoveBrandingMessage && !shouldShowLimitExceededMessage) {
      messageNodes.push( /*#__PURE__*/_jsx(UIUpgradeBanner, {
        upgradeKey: "blog-editor-remove-branding-preview-frame-top"
      }));
    }
    if (!isUngatedForPatagonia) {
      messageNodes.push( /*#__PURE__*/_jsx(AnnouncementBanner, {
        bannerKey: "patagonia",
        consumerName: "blog-editor-ui",
        shouldPersistSeenState: true,
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "announcementBanner.patagonia.title"
        }),
        alertType: "danger",
        showAgainAfterDates: [FEB_09_2024, FEB_16_2024, FEB_23_2024],
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "announcementBanner.patagonia.body_jsx",
          elements: {
            UILink
          }
        })
      }, "coming-soon-banner-patagonia"));
    }
    if (blogHasInvalidModuleBodies) {
      messageNodes.push( /*#__PURE__*/_jsx(InvalidModuleBodyWarning, {}));
    }
    return messageNodes;
  }, [blogHasInvalidModuleBodies, isUngatedForPatagonia, shouldShowLimitExceededMessage, shouldShowRemoveBrandingMessage, shouldShowSmartRulePreviewToolbar]);
  if (memoizedMessageNodes.length) {
    return /*#__PURE__*/_jsx(MessagingWrapper, {
      className: "contentEditor-iframe-messaging-area",
      children: memoizedMessageNodes
    });
  }
  return null;
};
export default BlogIframeMessagingAreaContainer;